import { createContext } from 'react';

const IsAnonymizedContext = createContext<boolean>(false);

export default IsAnonymizedContext;
